module.exports = __webpack_public_path__ + "static/media/loader.639d8898.svg";